import actions from "./actions";

const initialState = {
  detail: {},
  detailForLayout: {},
  loading: false,
  error: false,
  datetimeSetting: {},
  shutdownResponse: {},
  resetResponse: {},
  resetError: false,
  isSystemDetailFetched: false,
  isSystemDetailFetchedForLayout: false,
  importStatus: "unknown",
  importError: false,
};

export default function settingReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
